import { render } from "./Role.vue?vue&type=template&id=58991aed&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=58991aed&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58991aed"]])

export default __exports__